import type { MarketGroupsApi } from "@/v2/api/metadata/market-groups";
import type { ContentTab, DialogTabSaveContext } from "@/v2/framework/dialog/types";
import { marketGroupConfigurationSaveRef } from "./configuration/save-ref";

async function save(_ctx: DialogTabSaveContext): Promise<void> {
  if (!marketGroupConfigurationSaveRef.value) return;
  await marketGroupConfigurationSaveRef.value();
}

export function createConfigurationTab(marketGroupsApi: MarketGroupsApi): ContentTab {
  return {
    id: "configuration",
    label: "Configuration",
    save,
    children: [
      {
        type: "component",
        component: () => import("./configuration/MarketGroupConfigurationFields.vue"),
        props: { marketGroupsApi },
      },
    ],
  };
}
